import type { CardVariant } from "../api/cards";

export type Color = "red" | "yellow" | "blue" | "purple" | "none";

/** Prefer the explicit color; fall back to the 1/2/3/4 pitch convention. */
export function colorOf(variant: CardVariant): Color {
  const color = (variant.color ?? "").toLowerCase();
  if (
    color === "red" ||
    color === "yellow" ||
    color === "blue" ||
    color === "purple"
  ) {
    return color;
  }
  if (variant.pitch === "1") return "red";
  if (variant.pitch === "2") return "yellow";
  if (variant.pitch === "3") return "blue";
  if (variant.pitch === "4") return "purple";
  return "none";
}

const RARITY_LABELS: Record<string, string> = {
  B: "Basic",
  T: "Token",
  C: "Common",
  R: "Rare",
  S: "Super Rare",
  M: "Majestic",
  L: "Legendary",
  F: "Fabled",
  P: "Promo",
  V: "Marvel",
};

/** Display label for a rarity code. */
export function rarityLabel(code: string | null): string | null {
  if (!code) return null;
  return RARITY_LABELS[code] ?? code;
}

export function colorLabel(variant: CardVariant): string {
  const color = colorOf(variant);
  if (color !== "none") return color[0]!.toUpperCase() + color.slice(1);
  return variant.pitch ? `Pitch ${variant.pitch}` : "Colorless";
}

export function fabraryUrl(variant: CardVariant): string {
  const name = variant.name
    .toLowerCase()
    .replace(/['\u2019]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  const color = colorOf(variant);
  const slug = color === "none" ? name : `${name}-${color}`;
  return `https://fabrary.net/cards/${slug}`;
}
